import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=38bbf1c2&"
import script from "./TabsList.vue?vue&type=script&lang=js&"
export * from "./TabsList.vue?vue&type=script&lang=js&"
import style0 from "./TabsList.vue?vue&type=style&index=0&id=38bbf1c2&prod&stype=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports